module.exports = __webpack_public_path__ + "static/img/gz_14.86096d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_14.jpg
// module id = 6Ma1
// module chunks = 0